import { render, staticRenderFns } from "./GeneratingMessage.vue?vue&type=template&id=5b879d1c&scoped=true"
import script from "./GeneratingMessage.vue?vue&type=script&lang=js"
export * from "./GeneratingMessage.vue?vue&type=script&lang=js"
import style0 from "./GeneratingMessage.vue?vue&type=style&index=0&id=5b879d1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b879d1c",
  null
  
)

export default component.exports